module.exports = new __parcel__URL__("posterama.49d44a8e.webp").toString();